'use client';

import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';

interface CartItemRemoveButtonProps {
  onRemove: () => void;
  label?: string;
  dataTestId?: string;
}

export function CartItemRemoveButton({
  onRemove,
  label = 'Remover',
  dataTestId = DataTestIdEnum.CART_ITEM_REMOVE_BUTTON,
}: CartItemRemoveButtonProps) {
  return (
    <Button
      variant="text"
      startIcon={faTrash}
      startIconSize="1x"
      className="h-10 w-full text-base text-green-500"
      onClick={onRemove}
      data-testid={dataTestId}
    >
      {label}
    </Button>
  );
}
